import type { Resident, SignatureTrack } from '@/types';

import styles from './SignatureList.module.css';

interface SignatureListProps {
  artist: Resident;
}

export default function SignatureList({ artist }: SignatureListProps) {
  const tracks: SignatureTrack[] =
    artist.signature.length > 0
      ? artist.signature
      : [{ title: '— TBA —', length: '—', year: '—' }];

  return (
    <section className={styles.section}>
      <header className={styles.head}>
        <span className={styles.num}>/ 01</span>
        <span className={styles.ttl}>SIGNATURE</span>
        <span className={styles.meta}>SELECTED WORKS · PLACEHOLDERS</span>
      </header>
      <div className={styles.list}>
        {tracks.map((s, k) => {
          const seed = s.title
            .split('')
            .reduce((h, c) => ((h << 5) - h + c.charCodeAt(0)) | 0, k * 17);
          const bars = Array.from({ length: 64 }, (_, i) => {
            const v = Math.sin(seed * 0.13 + i * 0.41) * Math.cos(seed * 0.07 + i * 0.21);
            return 18 + Math.abs(v) * 78;
          });
          return (
            <a
              key={`${s.title}-${k}`}
              href={artist.links.soundcloud ?? '#'}
              target="_blank"
              rel="noreferrer"
              className={styles.track}
            >
              <span className={styles.play} aria-hidden="true">
                ▶
              </span>
              <span className={styles.num}>/{String(k + 1).padStart(2, '0')}</span>
              <span className={styles.meta}>
                <span className={styles.title}>{s.title}</span>
                <span className={styles.sub}>
                  {s.year} · {s.length}
                </span>
              </span>
              <span className={styles.wave} aria-hidden="true">
                {bars.map((h, i) => (
                  <i key={i} style={{ height: `${h}%` }} />
                ))}
              </span>
              <span className={styles.rt}>
                <span>{s.length}</span>
                <span>MOCT / {s.year}</span>
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
